import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Mail, MapPin } from "lucide-react";

const Footer = () => {
  const quickLinks = [
    { name: "About Us", path: "/about" },
    { name: "Our Campaigns", path: "/campaigns" },
    { name: "Latest News", path: "/blog" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact Us", path: "/contact" },
  ];

  const campaigns = [
    { name: "Orphanage Outreach", path: "/campaigns/charity-faith-hope" },
    { name: "Healthcare Support", path: "/campaigns/national-hospital" },
    { name: "Skills Training", path: "/campaigns/shoes-for-all" },
    { name: "Community Outreach", path: "/campaigns/police-appreciation" },
    { name: "Donate", path: "/donate" },
  ];

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div>
            <Link to="/" className="block mb-6">
              <img 
                src="/logo.png" 
                alt="Oshoke Alasa Foundation" 
                className="h-14 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Combating poverty, providing healthcare, and supporting communities across Nigeria with compassion and purpose.
            </p>
            <div className="flex gap-4">
              <a href="https://web.facebook.com/people/Oshoke-Alasa-Fdn/61581272517600/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 hover:bg-primary rounded-full flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://x.com/OshokeAlasaFdn" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 hover:bg-primary rounded-full flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/oshokealasafdn/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 hover:bg-primary rounded-full flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-gray-400 hover:text-primary transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Campaigns */}
          <div>
            <h3 className="font-semibold text-lg mb-6">Our Work</h3>
            <ul className="space-y-3">
              {campaigns.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-gray-400 hover:text-primary transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">No.1, Olaniran Olanyinka Street, Behind NNPC Filling Station, Prince and Princess Junction, Abuja</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                <a href="mailto:Oshokealasa.foundation@gmail.com" className="text-gray-400 hover:text-primary text-sm transition-colors">Oshokealasa.foundation@gmail.com</a>
              </li>
            </ul>
            <Link
              to="/donate"
              className="mt-6 inline-block bg-primary hover:bg-primary-dark text-white px-6 py-2.5 rounded-full font-medium text-sm transition-colors"
            >
              DONATE NOW
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">© 2024 Oshoke Alasa Foundation. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/about" className="text-gray-400 hover:text-primary text-sm transition-colors">About</Link>
            <Link to="/contact" className="text-gray-400 hover:text-primary text-sm transition-colors">Contact</Link>
            <Link to="/donate" className="text-gray-400 hover:text-primary text-sm transition-colors">Donate</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
